import axios from 'axios'
import {API_ADMIN} from '@/utils/constants/Api'
import {PaymentModel} from '@/payment/models/PaymentModel'
import { BaseAssociableEntity, BaseChannelBackendAssociation } from '@c2b/muven-commons'
import { IEntityAssociation } from '../../utils/interfaces/EntityAssociationInterface'
import { IFilterList } from '../../utils/interfaces/FilterListInterface'

class PaymentService implements IEntityAssociation {
    getPayments(page:number, filter:IFilterList):Promise<PaymentModel[]> {
        return axios.get(`${API_ADMIN}payments?page=${page}${filter.toPartialQueryString()}`)
            .then(({data}) => {
                return data.map((c:PaymentModel) => {
                    return new PaymentModel(c)
                })
            })
    }

    getEntitiesInBackend(channelId:number):Promise<BaseAssociableEntity[]> {
        return axios.get(`${API_ADMIN}payments/in_muven/from_channel/${channelId}`)
            .then(({data}) => {
                return data.map((b:BaseAssociableEntity) => new BaseAssociableEntity(b))
            })
    }

    getEntitiesInChannel(channelId:number):Promise<BaseAssociableEntity[]> {
        return axios.get(`${API_ADMIN}payments/in_channel/${channelId}`)
            .then(({data}) => {
                return data.map((b:BaseAssociableEntity) => new BaseAssociableEntity(b))
            })
    }

    getPaymentById(id:number):Promise<PaymentModel> {
        return axios.get(`${API_ADMIN}payments/${id}`)
            .then(({data}) => {
                return new PaymentModel(data)
            })
    }

    associateChannelEntitiesWithBackendEntities(associationList:BaseChannelBackendAssociation[], channelId:number):Promise<any> {
        return axios.post(`${API_ADMIN}payments/association/in_channel/${channelId}`, associationList)
            .then(({data}) => {
                return data
            })    
    }

    updateAllowExportInPayment(idPayment: number, allowExport:boolean):Promise<any> {
        return axios.patch(`${API_ADMIN}payments/${idPayment}/allow_export/${allowExport}`)
            .then(({data}) => {
                return data
            })
    }

    updateAllowExportInPaymentChannel(idPaymentChannel: number, allowExport:boolean):Promise<any> {
        return axios.patch(`${API_ADMIN}payments/channel/allow_export/${idPaymentChannel}/${allowExport}`)
            .then(({data}) => {
                return data
            })
    }
}

export default new PaymentService()
